'use strict';

angular.module('web2print.recipients')
  .directive('companySearchbox', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/recipients/company/searchbox/searchbox.html',
      controller: 'CompanyCtrl',
      controllerAs: 'ctrl',
      bindToController: true,
      scope: {
        model: '=searchModel',
        placeholder: '@searchPlaceholder'
      }
    };
  });
